/**
 * "Something about unread messages just changed."
 *
 * Opening a conversation marks it read, and the badge in the top bar should
 * drop at that moment rather than at its next poll -- otherwise the badge
 * insists there is something new while you are looking straight at it. A DOM
 * event rather than shared state, because the two live in unrelated parts of
 * the tree and this is the only thing they need to say to each other.
 */
const EVENT = "rr:unread-changed";

export function notifyUnreadChanged(): void {
  window.dispatchEvent(new Event(EVENT));
}

export function onUnreadChanged(callback: () => void): () => void {
  window.addEventListener(EVENT, callback);
  return () => window.removeEventListener(EVENT, callback);
}
